import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { RouterModule } from "@angular/router";
import { StingrayCommonModule } from "@modules/common/common.module";
import { LoginRecoverEmailAddressComponent } from "@modules/login-recover-email-address/components/login-recover-email-address/login-recover-email-address.component";
import { LOGIN_RECOVER_EMAIL_ADDRESS_ROUTES } from "@modules/login-recover-email-address/login-recover-email-address.routes";
import { LoginSharedModule } from "@modules/login-shared/login-shared.module";

@NgModule({
    declarations: [
        LoginRecoverEmailAddressComponent
    ],
    imports: [
        CommonModule,
        StingrayCommonModule,
        LoginSharedModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        RouterModule.forChild(LOGIN_RECOVER_EMAIL_ADDRESS_ROUTES),
    ],
})
export class LoginRecoverEmailAddressModule {
}